export default __webpack_public_path__ + "static/media/fundingCard.d895b980.svg";